var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBall9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "url(#paint0_radial_315_62)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66477 1.52557C2.74953 1.52557 2.82978 1.53906 2.90554 1.56605C2.9813 1.59257 3.0483 1.63447 3.10653 1.69176C3.16525 1.74905 3.21117 1.82386 3.24432 1.91619C3.27794 2.00805 3.29498 2.11932 3.29545 2.25C3.29593 2.36932 3.28101 2.47656 3.25071 2.57173C3.22088 2.66643 3.17803 2.74716 3.12216 2.81392C3.06676 2.88068 3 2.93182 2.92188 2.96733C2.84422 3.00237 2.75758 3.01989 2.66193 3.01989C2.55445 3.01989 2.45999 2.99929 2.37855 2.9581C2.29711 2.9169 2.23224 2.86151 2.18395 2.7919C2.13565 2.7223 2.10748 2.64489 2.09943 2.55966H2.48864C2.49811 2.60369 2.51894 2.63565 2.55114 2.65554C2.58333 2.67495 2.62027 2.68466 2.66193 2.68466C2.74527 2.68466 2.80611 2.64867 2.84446 2.5767C2.88329 2.50426 2.90294 2.40767 2.90341 2.28693H2.89489C2.87642 2.33144 2.84848 2.36955 2.81108 2.40128C2.77367 2.433 2.73011 2.45739 2.6804 2.47443C2.63068 2.49148 2.57813 2.5 2.52273 2.5C2.43513 2.5 2.35843 2.48035 2.29261 2.44105C2.2268 2.40128 2.17543 2.34706 2.13849 2.27841C2.10156 2.20928 2.08286 2.13068 2.08239 2.04261C2.08191 1.93939 2.1063 1.84896 2.15554 1.77131C2.20478 1.69366 2.2732 1.63329 2.3608 1.5902C2.44839 1.54711 2.54972 1.52557 2.66477 1.52557ZM2.66761 1.82386C2.62831 1.82386 2.59328 1.83286 2.5625 1.85085C2.5322 1.86884 2.50829 1.89323 2.49077 1.92401C2.47372 1.95478 2.46544 1.98958 2.46591 2.02841C2.46638 2.06723 2.47514 2.10204 2.49219 2.13281C2.50971 2.16359 2.53338 2.18797 2.56321 2.20597C2.59351 2.22396 2.62831 2.23295 2.66761 2.23295C2.6965 2.23295 2.72325 2.22798 2.74787 2.21804C2.77249 2.20762 2.7938 2.19318 2.81179 2.17472C2.83026 2.15578 2.84446 2.134 2.8544 2.10938C2.86482 2.08428 2.86979 2.05729 2.86932 2.02841C2.86884 1.98958 2.85985 1.95478 2.84233 1.92401C2.82481 1.89323 2.8009 1.86884 2.7706 1.85085C2.74029 1.83286 2.70597 1.82386 2.66761 1.82386Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_315_62",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.5 2.5) rotate(90) scale(2.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall9);
export default __webpack_public_path__ + "static/media/ball9.4a5395d1fc03b979664a02a1c3a2a2dc.svg";
export { ForwardRef as ReactComponent };